export default __webpack_public_path__ + "static/media/plus.b00a8da4.svg";